import { render, staticRenderFns } from "./CorrectionCompanyDataModal.container.vue?vue&type=template&id=8245199a&"
import script from "./CorrectionCompanyDataModal.container.vue?vue&type=script&lang=ts&"
export * from "./CorrectionCompanyDataModal.container.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports